import React, { Component } from "react";
import Modal from "../../../common/Modal";

export default class ConfirmDeleteModal extends Component {
  render() {
    const { account, accountType, onConfirm, onClose, show } = this.props;

    return (
      <Modal show={show} onClose={onClose}>
        <div className="modal-header bg-danger text-white">
          <h5 className="modal-title">Confirm Account Removal</h5>
          <button
            type="button"
            className="btn-close btn-close-white"
            onClick={onClose}
            aria-label="Close"
          ></button>
        </div>
        <div className="modal-body">
          <p>Are you sure you want to request removal of this account?</p>
          <div className="alert alert-warning">
            <strong>Account:</strong> {account}
            <br />
            <strong>Type:</strong> {accountType}
          </div>
          <p className="text-muted small">
            This action will send a removal request to compliance. The account
            will not be removed until approved.
          </p>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => {
              onConfirm(account, accountType);
              onClose();
            }}
          >
            Request Removal
          </button>
        </div>
      </Modal>
    );
  }
}
